/* Modulo: Product Browse (pbr)
   Tab swap, rail arrows, and a quick-add that UPGRADES a form which already
   works without JS.

   `window.moduloLazyInit` is deliberately NOT used — it does not exist.
   Roadmap rule 5 mandates it and `modulo-core.js` is not on disk. */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;

  function root() {
    var r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return r || '/';
  }

  /* A live query, not a load-time boolean, or a mid-session toggle is ignored. */
  function reduced() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function scrollBy(el, delta) {
    if (reduced()) { el.scrollLeft += delta; return; }
    if (el.scrollBy) el.scrollBy({ left: delta, behavior: 'smooth' });
    else el.scrollLeft += delta;
  }

  /* A non-2xx must become a real Error carrying its status, or a 422 takes the
     success path on an add that never happened. `fetch` does not reject on 422. */
  function thenJson(res) {
    return res.json()
      .catch(function () { return {}; })
      .then(function (data) {
        if (res.ok) return data;
        var err = new Error((data && (data.description || data.message)) || 'Could not add');
        err.status = res.status;
        throw err;
      });
  }

  function initSection(sectionEl) {
    if (sectionEl.moduloPbr) return;
    sectionEl.moduloPbr = true;

    var tabs = [].slice.call(sectionEl.querySelectorAll('[data-pbr-tab]'));
    var panels = [].slice.call(sectionEl.querySelectorAll('[data-pbr-panel]'));
    var nav = sectionEl.querySelector('[data-pbr-nav]');
    var prev = sectionEl.querySelector('[data-pbr-arrow="prev"]');
    var next = sectionEl.querySelector('[data-pbr-arrow="next"]');

    function activePanel() {
      for (var i = 0; i < panels.length; i++) {
        if (panels[i].classList.contains('is-active')) return panels[i];
      }
      return panels[0] || null;
    }

    function activeRail() {
      var p = activePanel();
      return p ? p.querySelector('[data-pbr-rail]') : null;
    }

    /* ─── arrows ──────────────────────────────────────────────────────────
       Self-hide when nothing overflows. `nav.hidden` alone does nothing —
       an author `display: flex` beats the UA's [hidden] rule — so the
       stylesheet restates it (the sr lesson). */
    function syncArrows() {
      var rail = activeRail();
      if (!nav || !rail) return;
      var max = rail.scrollWidth - rail.clientWidth - 1;
      var fits = max <= 0;
      nav.hidden = fits;
      if (prev) prev.disabled = rail.scrollLeft <= 0;
      if (next) next.disabled = rail.scrollLeft >= max;
    }

    function step(dir) {
      var rail = activeRail();
      if (!rail) return;
      var card = rail.querySelector('[data-pbr-card]');
      if (!card) return;
      var gap = parseFloat(getComputedStyle(rail).columnGap || '20') || 20;
      scrollBy(rail, (card.getBoundingClientRect().width + gap) * dir);
    }

    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });

    for (var r = 0; r < panels.length; r++) {
      var rl = panels[r].querySelector('[data-pbr-rail]');
      if (rl) rl.addEventListener('scroll', syncArrows, { passive: true });
    }

    /* ─── tabs ───────────────────────────────────────────────────────────── */
    function select(id, focus) {
      for (var i = 0; i < tabs.length; i++) {
        var on = tabs[i].getAttribute('data-pbr-tab') === id;
        tabs[i].setAttribute('aria-selected', on ? 'true' : 'false');
        tabs[i].setAttribute('tabindex', on ? '0' : '-1');
        if (on && focus) tabs[i].focus();
      }
      for (var j = 0; j < panels.length; j++) {
        panels[j].classList.toggle('is-active', panels[j].getAttribute('data-pbr-panel') === id);
      }
      var rail = activeRail();
      if (rail) rail.scrollLeft = 0;
      syncArrows();
    }

    for (var t = 0; t < tabs.length; t++) {
      (function (btn) {
        btn.setAttribute('tabindex', btn.getAttribute('aria-selected') === 'true' ? '0' : '-1');
        btn.addEventListener('click', function () {
          select(btn.getAttribute('data-pbr-tab'), false);
        });
        /* Roving keyboard nav across the tablist. */
        btn.addEventListener('keydown', function (e) {
          var i = tabs.indexOf(btn);
          var n = -1;
          if (e.key === 'ArrowRight') n = (i + 1) % tabs.length;
          else if (e.key === 'ArrowLeft') n = (i - 1 + tabs.length) % tabs.length;
          else if (e.key === 'Home') n = 0;
          else if (e.key === 'End') n = tabs.length - 1;
          if (n < 0) return;
          e.preventDefault();
          select(tabs[n].getAttribute('data-pbr-tab'), true);
        });
      })(tabs[t]);
    }

    /* ─── quick-add ───────────────────────────────────────────────────────
       Progressive enhancement: the markup is a real product form, so JS-off
       still adds correctly. This only intercepts to keep the shopper on the
       page and tell the theme its cart changed. */
    sectionEl.addEventListener('submit', function (e) {
      var form = e.target.closest ? e.target.closest('[data-pbr-form]') : null;
      if (!form) return;
      /* Stand down if something else already owns this submit (e.g. the app's
         own bundle block, which renders inside product forms). */
      if (e.defaultPrevented) return;
      e.preventDefault();

      var button = form.querySelector('[data-pbr-add]');
      var card = form.closest('[data-pbr-card]');
      if (!card) return;

      /* The in-flight flag lives on the CARD, not the button — a per-button
         flag cannot see its sibling, so two controls would mean two concurrent
         adds and a quantity the shopper never asked for (the pqb lesson). */
      if (card.moduloPbrBusy) return;
      card.moduloPbrBusy = true;
      if (button) button.classList.add('is-busy');

      function done() {
        card.moduloPbrBusy = false;
        if (button) button.classList.remove('is-busy');
      }

      /* Built from the FORM, never a hand-written {items:[…]} body — that is
         what keeps `properties[…]`, `selling_plan` and anything an app
         injected, which a synthetic body silently drops (the pfr rule). */
      window.fetch(root() + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          /* Opts out of the bundle block's in-flight fetch shim, which would
             otherwise answer with a synthetic 200 and take the success path on
             an add that never happened. */
          'X-Modulo-Internal': 'product-browse'
        },
        /* No `sections` here on purpose: an invalid one returns 400 for the
           WHOLE request while the add still succeeds, so a caller treating
           non-2xx as failure would skip every refresh on an item now in the
           cart. ModuloCart.after() asks for sections on the /cart.js read. */
        body: new FormData(form)
      })
        .then(thenJson)
        .then(function () {
          /* Fails OPEN when the engine is absent: a successful AJAX add with no
             way to tell the theme is strictly WORSE than the native POST, which
             at least lands on a correct cart page. */
          if (window.ModuloCart) return window.ModuloCart.after({ open: false });
          window.location.href = root() + 'cart';
        })
        .catch(function () {
          /* The form still works without us — hand the shopper back to the
             native path rather than silently swallowing the failure. */
          form.submit();
        })
        .then(done, done);
    });

    /* One observer per section; re-measures on any reflow. */
    if (window.ResizeObserver) {
      new window.ResizeObserver(syncArrows).observe(sectionEl);
    } else {
      window.addEventListener('resize', syncArrows);
    }

    if (document.fonts && document.fonts.ready) document.fonts.ready.then(syncArrows);
    syncArrows();
  }

  function bootstrap() {
    var els = document.querySelectorAll('[data-modulo-pbr]');
    for (var i = 0; i < els.length; i++) initSection(els[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }

  /* Re-init when the theme editor re-renders this section. */
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target && e.target.querySelector ? e.target.querySelector('[data-modulo-pbr]') : null;
    if (el) initSection(el);
  });
})();
